import { AbstractControl } from '@angular/forms';

/**
 * Extracts the `requiredLength` of a `Validators.maxLength` validator from a FormControl upfront,
 * by invoking the validator with a probe value longer than any realistic maxLength.
 * Returns `undefined` if no maxLength validator is present.
 */
export function getMaxLengthFromFormControl(control: AbstractControl | null | undefined): number | undefined {
  if (!control?.validator) {
    return undefined;
  }
  try {
    const probe = { value: 'a'.repeat(100001) } as AbstractControl;
    const errors = control.validator(probe);
    const requiredLength = errors?.['maxlength']?.['requiredLength'];
    return typeof requiredLength === 'number' ? requiredLength : undefined;
  } catch {
    return undefined;
  }
}
